import { LoggingServiceGlobalResourcesAdapter } from '../adapters'

export const logger = new LoggingServiceGlobalResourcesAdapter()
